import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { COMPANY, BRAND } from "@/lib/constants";
import LottiePlayer from "@/components/LottiePlayer";
import checkAnim from "@/assets/lottie/check-badge.json";

const Block = ({ title, rows }) => (
  <Reveal>
    <section aria-label={title} className="mt-12">
      <h2 className="hp-h3">{title}</h2>
      <dl className="mt-4 border-t border-slate-200">
        {rows.map(([k, v]) => (
          <div key={k} className="py-4 px-2 -mx-2 rounded border-b border-slate-200 grid sm:grid-cols-[16rem_1fr] gap-1 sm:gap-6 transition-colors hover:bg-[#f5f7fc]">
            <dt className="text-[14px] font-bold text-slate-500">{k}</dt>
            <dd className="text-[15px] text-slate-800 break-words">
              {Array.isArray(v) ? v.map((l) => <div key={l}>{l}</div>) : v}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  </Reveal>
);

export default function CompanyInformation() {
  return (
    <>
      <Seo title="Company Information"
        description="Legal name and registration details of HOUSEOFPROJECT TALENT AND BUSINESS MANAGEMENT PRIVATE LIMITED, the operating company behind House of Projects."
        path="/company-information" />
      <section data-testid="company-info" className="relative overflow-hidden">
        <div className="hp-hero-grid" aria-hidden="true" />
        <div className="hop-container relative py-16 md:py-24 max-w-4xl">
          <LottiePlayer className="absolute right-0 top-10 w-28 h-28 hidden md:block" data={checkAnim} loop={false} label="Registered company" />
          <Reveal>
            <p className="hp-label text-[var(--hop-brand)]">Company information</p>
            <h1 className="hp-h1 mt-5">Legal details.</h1>
            <p className="hp-lead mt-7">
              {BRAND.name} is the operating brand of {COMPANY.legalName}.
            </p>
          </Reveal>

          <Block title="Legal entity" rows={[
            ["Legal name", COMPANY.legalName],
            ["Entity type", COMPANY.entityType],
            ["Date of incorporation", COMPANY.incorporated],
            ["Corporate Identification Number (CIN)", COMPANY.cin],
          ]} />
        </div>
        <div className="hp-rule" aria-hidden="true" />
      </section>
    </>
  );
}
